export default ({
  id, stageId, secretaryId, value, object, observation, paymentDate, year, resourceOrigin, requesters, beneficiaries, regions
}) => {
  return {
    id: null,
    stageId,
    secretaryId,
    value: `R$ ${value}`,
    object,
    observation,
    paymentDate,
    year: year.toString(),
    resourceOrigin,

    requester: requesters.map((option) => option.name),
    beneficiary: beneficiaries.map((option) => option.name),

    region: regions.map(option => option.cityId),
    regionOptions: regions.map(({ cityId, stateId, city, stateAbbrev }) => (
      {
        id: cityId,
        stateId,
        name: city,
        stateAbbrev,
      }
    )),

    isCopy: true,
    isEditing: false,
}
};
